import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { elencoPostPerTutti } from '../../../../api-client/appPlayer';

/*
 * Post per tutti: annunci che il super admin pubblica e che compaiono nel feed di tutti gli utenti
 * (Arena e ogni punto dell'app che mostra il feed). La riga apre la scheda. Rotte /administration/feedPosts
 * (sportid-docs, «modifiche 9 ottobre», cap. 4).
 */

export const LIST_URL = '/superadmin/post-per-tutti';

const dataBreve = (v) => (v ? new Date(v).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');

export const messaggioRotta = (r) => r?.error || 'Operazione non riuscita.';

export const ListaPostPerTutti = () => {
    const navigate = useNavigate();
    const [righe, setRighe] = useState(null);
    const [errore, setErrore] = useState('');

    useEffect(() => {
        elencoPostPerTutti().then((r) => {
            if (!r || r.error) { setErrore(messaggioRotta(r)); setRighe([]); return; }
            setRighe(Array.isArray(r) ? r : r.items || []);
        });
    }, []);

    const data_column = [
        { Header: 'Pubblicato', Footer: 'Pubblicato', accessor: 'publishedAt', compact: true, disableGlobalFilter: true, Cell: ({ value }) => dataBreve(value) },
        { Header: 'Titolo', Footer: 'Titolo', accessor: 'title', larghezza: '60%' },
        { Header: 'Luogo', Footer: 'Luogo', accessor: 'location' },
    ];

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <TabellaLista
                openColumn={'title'}
                openRow={(row) => navigate(`${LIST_URL}/${row.id}`)}
                cardTitle={'Post per tutti'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per titolo'}
                hasFilter={false}
                hasAddMore={true}
                linkAddMore={`${LIST_URL}/nuovo`}
                labelAddMore={'Nuovo post'}
                data_column={data_column}
                data_json={righe}
                sort_by={'publishedAt'}
                sort_type={'desc'}
            />
        </>
    );
};

export default ListaPostPerTutti;
